import React from 'react'
import Policy from 'src/views/about/policy'

// ** SSR
import getServerSideProps from 'src/@core/services/ssr/serverProps'

export { getServerSideProps }

// eslint-disable-next-line no-unused-vars
const PolicyPage = props => {
  return <Policy />
}

export default React.memo(PolicyPage)
